import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles((theme) => ({
  loadingBalls: (props) => ({
    display: 'inline-flex',
    verticalAlign: 'middle',
    position: 'relative',
    '& > .ball': {
      flexGrow: 1,
      display: 'inline-block',
      background: theme.colors[props._color].normal,
      width: `${props.width / 3}px`,
      height: `${props.width / 3}px`,
      borderRadius: `${props.width / 3}px`,
      animation: `$zoom ${theme.speed.normal * 1.2}ms infinite linear alternate`,
      transform: 'scale(0.4, 0.4)',
      opacity: 0.4,
      '&:nth-child(odd)': {
        animationDelay: `${theme.speed.normal * 1.2}ms`,
      },
    },
  }),
  '@keyframes zoom': {
    from: {
      transform: 'scale(0.4, 0.4)',
      opacity: 0.6,
    },
    to: {
      transform: 'scale(1, 1)',
      opacity: 1,
    },
  },
}));

export default useStyle;
